import { render, staticRenderFns } from "./CustomerExplorer.vue?vue&type=template&id=20201d5b&"
import script from "./CustomerExplorer.vue?vue&type=script&lang=js&"
export * from "./CustomerExplorer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports